import { useCallback, useState } from "react";

import { deleteTeamProjectAccess } from "Api/teams/projectAccesses/deleteTeamProjectAccess.request";
import { useInvalidateProjectTeamAccess } from "Reducers/access/teams/teams.slice";
import { useInvalidateTeams } from "Reducers/organization/team/teamList.slice";
import { useInvalidateTeamProjectAccesses } from "Reducers/organization/team/teamProjectAccesses.slice";

export const useDeleteTeamProjectAccess = (organizationId: string) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const invalidateProjectTeamAccess = useInvalidateProjectTeamAccess();
  const invalidateTeamProjectAccess = useInvalidateTeamProjectAccesses();
  const invalidateTeams = useInvalidateTeams();

  const deleteProjectAccess = useCallback(
    async (teamId: string, projectId: string) => {
      setIsDeleting(true);
      await deleteTeamProjectAccess(teamId, projectId);
      setIsDeleting(false);
      invalidateProjectTeamAccess(projectId);
      invalidateTeamProjectAccess(teamId);
      invalidateTeams(organizationId);
    },
    [
      invalidateTeamProjectAccess,
      invalidateProjectTeamAccess,
      invalidateTeams,
      organizationId
    ]
  );

  return [deleteProjectAccess, isDeleting] as const;
};
